import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Logo } from "../components/Logo";
import { Mail, Lock, User as UserIcon, Gift, ArrowRight } from "lucide-react";

export default function Signup() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [referral, setReferral] = useState("");
  const [err, setErr] = useState(null);
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setErr(null);
    setLoading(true);
    const res = await register(email, password, name, referral);
    setLoading(false);
    if (res.ok) navigate("/dashboard");
    else setErr(res.error);
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-5 py-12">
      <div className="w-full max-w-md">
        <Link to="/" className="inline-block mb-8" data-testid="signup-back-home">
          <Logo size={28} />
        </Link>
        <div className="brut-card p-7 pop-in">
          <h1 className="font-display text-4xl font-black tracking-tight">Join the streak.</h1>
          <p className="mt-1 text-[var(--cs-ink-2)]">First task fee on us. Same-day cash.</p>

          <form onSubmit={submit} className="mt-7 space-y-4">
            <label className="block">
              <span className="text-xs uppercase tracking-widest font-bold">Name</span>
              <div className="mt-1.5 relative">
                <UserIcon size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-[var(--cs-ink-2)]" />
                <input
                  type="text"
                  required
                  data-testid="signup-name-input"
                  className="brut-input pl-10"
                  placeholder="Jamie Smith"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </div>
            </label>
            <label className="block">
              <span className="text-xs uppercase tracking-widest font-bold">Email</span>
              <div className="mt-1.5 relative">
                <Mail size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-[var(--cs-ink-2)]" />
                <input
                  type="email"
                  required
                  data-testid="signup-email-input"
                  className="brut-input pl-10"
                  placeholder="you@email.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
            </label>
            <label className="block">
              <span className="text-xs uppercase tracking-widest font-bold">Password</span>
              <div className="mt-1.5 relative">
                <Lock size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-[var(--cs-ink-2)]" />
                <input
                  type="password"
                  required
                  minLength={6}
                  data-testid="signup-password-input"
                  className="brut-input pl-10"
                  placeholder="At least 6 characters"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
            </label>
            <label className="block">
              <span className="text-xs uppercase tracking-widest font-bold">
                Referral code <span className="text-[var(--cs-ink-2)] normal-case font-normal">(optional)</span>
              </span>
              <div className="mt-1.5 relative">
                <Gift size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-[var(--cs-flame)]" />
                <input
                  type="text"
                  data-testid="signup-referral-input"
                  className="brut-input pl-10 uppercase tracking-wide"
                  placeholder="CASH-XXXXX"
                  value={referral}
                  onChange={(e) => setReferral(e.target.value)}
                />
              </div>
            </label>

            {err && (
              <div data-testid="signup-error" className="brut-card p-3 bg-red-50 text-red-700 text-sm font-semibold" style={{ boxShadow: "3px 3px 0 0 #b91c1c", borderColor: "#b91c1c" }}>
                {err}
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              data-testid="signup-submit-btn"
              className="brut-btn brut-btn-money w-full text-base py-4"
            >
              {loading ? "Creating..." : "Create account"} <ArrowRight size={18} />
            </button>
          </form>

          <div className="mt-6 text-sm text-[var(--cs-ink-2)]">
            Already have an account?{" "}
            <Link to="/login" className="font-bold underline" data-testid="signup-to-login">
              Log in
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
